export default __webpack_public_path__ + "static/media/icon-trip-white.13ae7892.svg";